import { render, staticRenderFns } from "./invadjustfrm.vue?vue&type=template&id=5235e841"
import script from "./invadjustfrm.vue?vue&type=script&lang=js"
export * from "./invadjustfrm.vue?vue&type=script&lang=js"
import style0 from "./invadjustfrm.vue?vue&type=style&index=0&id=5235e841&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports